<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <ManualDepositTable/>        
      </b-col>
    </b-row>
  </div>

</template>

<script>

export default {
  name: 'Manual Deposit'
}
</script>

<script>
  import ManualDepositTable from './ManualDepositTable.vue'

  export default {
    name: 'Manual Deposit',
    components: { ManualDepositTable }
  }
</script>



// WEBPACK FOOTER //
// src/views/manualDeposit/ManualDeposit.vue